import { render, staticRenderFns } from "./power.vue?vue&type=template&id=5a92d36a&scoped=true"
import script from "./power.vue?vue&type=script&lang=js"
export * from "./power.vue?vue&type=script&lang=js"
import style0 from "./power.vue?vue&type=style&index=0&id=5a92d36a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92d36a",
  null
  
)

export default component.exports